// import { EventBus } from "../../event-bus";
import { isEmpty as _isEmpty } from 'lodash';

const notification = {
  namespaced: true,
  state: () => ({}),
  preserveState: false,
  getters: {
    count: (state) => (types) => {
      if (types) {
        types = Array.isArray(types) ? types : [types];
      }
      return !_isEmpty(state)
        ? Object.keys(state).reduce((accom, keyType) => {
          if (!types || types.indexOf(keyType) >= 0) {
            return (accom += state[keyType]);
          }
          return accom;
        }, 0)
        : 0;
    },
  },
  mutations: {
    setCount(state, { type, count }) {
      state[type] = count;
    },
    increaseCount(state, { type }) {
      state[type] = state[type] ? state[type] + 1 : 1;
    },
    ack(state, { type }) {
      Object.entries(state).forEach((keyValue) => {
        state[keyValue[0]] = keyValue[0] == type ? 0 : state[keyValue[0]];
      });
    },
    ackAll(state) {
      Object.entries(state).forEach((keyValue) => {
        state[keyValue[0]] = 0;
      });
    },
  },
  actions: {
    received({ commit }, { type, data }) {
      // EventBus.$emit(type, data);
      commit('increaseCount', { type });
    },
    ack({ commit }, { type }) {
      commit('ack', { type });
    },
    ackAll({ commit }) {
      commit('ackAll');
    },
  },
};
export default notification;
